import React from "react";
import { Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { RoutableLink } from "../../react/RoutableLink";
import { FavoriteButton } from "../../react/FavoriteButton";
import css from "./index.module.scss";

const BasicPageBanner = (props) => {
  const { fields, sitecoreContext } = props;
  const favorites = sitecoreContext?.savedItems?.favorites || [];
  const isEditing = sitecoreContext && (sitecoreContext.pageEditing == true || sitecoreContext.pageState == 'preview');

  return (
    <section
      className={`${css.container} ${
        (fields?.link?.value?.href && fields?.linkText?.value) ? css.hasCta : css.noCta
        } single-col-inner ${isEditing ? css.isEditing : ''}`}
    >
      <div className={css.titleContainer}>
        <Text
          field={fields.pageTitle}
          tag="h1"
          className={'serif-head-2'}
        />
        {fields?.favoriteButton?.value && (
          <FavoriteButton
            className={css.favoriteButton}
            itemId={sitecoreContext?.itemId}
            isFavorited={favorites.indexOf(sitecoreContext?.itemId) >= 0}
          />
        )}
      </div>
      {fields?.link?.value?.href && fields?.linkText?.value && (
        <div className={css.ctaContainer}>
          <RoutableLink
            field={fields.link}
            className={css.cta}
            data-chevron={true}
          >
            <Text field={fields.linkText} />
          </RoutableLink>
        </div>
      )}
    </section>
  );
};

export default withSitecoreContext()(BasicPageBanner);